import { FacebookIcon, RedditIcon, TelegramIcon, XIcon } from '#features/ui';

export const sharingOptions = [
  {
    name: 'facebook',
    icon: <FacebookIcon />,
    url: (postUrl) =>
      `https://www.facebook.com/sharer.php?u=${postUrl}&utm_medium=sharing_facebook`,
  },
  {
    name: 'telegram',
    icon: <TelegramIcon />,
    url: (postUrl, title) =>
      `https://t.me/share/url?url=${postUrl}&text=${title}&utm_medium=sharing_telegram`,
  },
  {
    name: 'reddit',
    icon: <RedditIcon />,
    url: (postUrl, title) =>
      `https://reddit.com/submit?url=${postUrl}&title=${title}&utm_medium=sharing_reddit`,
  },
  {
    name: 'x',
    icon: <XIcon />,
    url: (postUrl, title) =>
      `https://x.com/share?url=${postUrl}&text=${title}&utm_medium=sharing_x`,
  },
] satisfies {
  name: string;
  icon: React.ReactNode;
  url: (postUrl: string, title: string) => string;
}[];
